import { COLORS } from '../constants';

type CustomLabelProps = {
  x?: number | string;
  y?: number | string;
  width?: number | string;
  height?: number | string;
  value?: string | number;
  offset?: number;
  viewBox?: unknown;
  position?: string;
  index?: number;
  [key: string]: unknown;
};

const CustomLabel = (props: CustomLabelProps) => {
  const { x, y, width, value } = props;

  // Type guard: ensure we have valid numeric values and convert value to string
  if (
    typeof x !== 'number' ||
    typeof y !== 'number' ||
    typeof width !== 'number' ||
    (typeof value !== 'string' && typeof value !== 'number')
  ) {
    return null;
  }

  // Convert value to string if it's a number
  const stringValue = typeof value === 'number' ? String(value) : value;
  const valueArray = stringValue.split(',');
  const isProperty = valueArray[0].split(':')[1] === 'true';
  const isMarketMedian = valueArray[1].split(':')[1] === 'true';
  const count = Number(valueArray[2].split(':')[1]);
  const maxCount = Number(valueArray[3].split(':')[1]);

  const isPropertyAndMarketMedianSame = isProperty && isMarketMedian;
  const dotColor = isProperty ? COLORS.BLUE500 : COLORS.YELLOW400;
  const oppositeDotColor = dotColor === COLORS.BLUE500 ? COLORS.YELLOW400 : COLORS.BLUE500;
  const radius = width / 4;

  const oneFifthOfMaxCount = Math.floor(Math.round(maxCount) / 5);

  const heightAdjustedCount = isPropertyAndMarketMedianSame ? oneFifthOfMaxCount * 2 : oneFifthOfMaxCount;

  const dotHeight = count <= heightAdjustedCount ? y - radius * 2 : y + radius * 2;
  const secondaryDotHeight = count <= heightAdjustedCount ? y - radius * 5 : y + radius * 5;

  if (isProperty || isMarketMedian) {
    return (
      <g>
        <circle cx={x + width / 2} cy={dotHeight} r={radius} fill={dotColor} />
        {isPropertyAndMarketMedianSame && (
          <circle cx={x + width / 2} cy={secondaryDotHeight} r={radius} fill={oppositeDotColor} />
        )}
      </g>
    );
  }

  return null;
};

export default CustomLabel;
